export default __webpack_public_path__ + "static/media/Email.e524c164.png";